function getPublishedItems(items) {
  return items.filter(x => x.published)
}

export default getPublishedItems
